/** @format */
import { FilterQuery } from '@toucan/common/services/search/types';

import { DataLayerEventType } from '@toucan/client/global/analytics';

import { trackViaDataLayer } from '@toucan/client/shared/helpers/analytics';

import {
    ListingPageType,
    ListingPageVariant,
    SearchResultsType,
} from '@toucan/client/features/search/components/listing-page';

type SearchResultsDataLayerParams = {
    searchResults: SearchResultsType;
    pageType: ListingPageType;
    searchVariant: ListingPageVariant;
    searchFilters: FilterQuery;
    sortedBy: string;
};

export function addSearchResultsToDataLayer({
    searchResults,
    pageType,
    searchVariant,
    searchFilters,
    sortedBy,
}: SearchResultsDataLayerParams) {
    const results = searchResultsToIds(searchResults.results, searchVariant);
    const event = DataLayerEventType.SEARCH_RESULTS;
    const filters = searchFiltersToDataLayerFilters(searchFilters);

    trackViaDataLayer({
        event,
        pageType,
        searchVariant,
        results,
        filters,
        sortedBy,
    });
}

function searchResultsToIds(
    results: SearchResultsType['results'],
    searchVariant: ListingPageVariant
) {
    return results
        .map((result) => {
            switch (searchVariant) {
                case ListingPageVariant.MODEL:
                    return result.modelId?.values?.[0];
                case ListingPageVariant.PRODUCT:
                    return result.productSku?.values?.[0];
            }
        })
        .filter(Boolean)
        .join(',');
}

function searchFiltersToDataLayerFilters(searchFilters: FilterQuery) {
    return Object.entries(searchFilters).map<{
        name: string;
        value: unknown;
    }>(([key, value]) => ({
        name: key,
        value,
    }));
}
